import { default as PaymentPursesListItemDefault } from './PaymentPursesListItem/View';
import { default as PaymentPursesListItem4 } from '../../themes/4/components/Payments/PaymentPursesListItem';

import ThemedComponent from '../../hoc/ThemedComponent';

const ThemedPaymentPursesListItems = {
  default: PaymentPursesListItemDefault,
  // 4: PaymentPursesListItem4,
};

export const PaymentPursesListItemView = ThemedComponent(ThemedPaymentPursesListItems);
